import {NgModule} from '@angular/core';
import {SparklineComponent} from './sparkline.component';

@NgModule({
    declarations: [
        SparklineComponent
    ],
    exports: [
        SparklineComponent
    ]
})
export class SparklineModule {}
